// Identificadores canónicos de los tabs del DashboardReports. Estos strings son
// el contrato compartido entre: (a) el `TAB_REGISTRY` de DashboardReports.vue
// (qué componente montar + fallback), (b) el `ROW_TO_TAB` de ResultadosTab.vue
// (navegación cross-tab desde el P&L) y (c) el `data-theme="X"` de cada tab
// hijo. La navegación VISIBLE de los tabs vive en el sidebar
// (`components/layout/navConfig.js`). Centralizar los ids acá evita typos
// silenciosos entre esos lugares.
export const TAB_IDS = Object.freeze({
    DASHBOARD: "dashboard",
    RESULTADOS: "resultados",
    VENTAS: "ventas",
    COSTOS: "costos",
    GASTOS: "gastos",
    RENTABILIDAD: "rentabilidad",
    NO_OPER: "no_oper",
    ACTIVOS: "activos",
    KPIS: "kpis",
    // Balance (aún sin vista propia → ComingSoon en el registry).
    BALANCE_RESUMEN: "balance_resumen",
    PASIVOS: "pasivos",
    PATRIMONIO: "patrimonio",
    BALANCE_KPIS: "balance_kpis",
    // Proyecciones Financieras (grupo propio en el sidebar, sección
    // "proyecciones"; tabs aún ComingSoon).
    PRESUPUESTO: "presupuesto",
    PROYECCION_CAJA: "proyeccion_caja",
});

// Secciones del sidebar que renderizan DashboardReports (navConfig.js /
// Dashboard.vue). Cambiar de tab desde una vista escribe también la sección
// en la URL, así el sidebar acompaña al salto (Dashboard → Ventas).
export const SECTION_IDS = Object.freeze({
    REPORTS: "reports",
    ESTADO_RESULTADOS: "estado_resultados",
    BALANCE: "balance",
    PROYECCIONES: "proyecciones",
});

const TAB_SECTION = Object.freeze({
    [TAB_IDS.DASHBOARD]: SECTION_IDS.REPORTS,
    [TAB_IDS.RESULTADOS]: SECTION_IDS.ESTADO_RESULTADOS,
    [TAB_IDS.VENTAS]: SECTION_IDS.ESTADO_RESULTADOS,
    [TAB_IDS.COSTOS]: SECTION_IDS.ESTADO_RESULTADOS,
    [TAB_IDS.GASTOS]: SECTION_IDS.ESTADO_RESULTADOS,
    [TAB_IDS.RENTABILIDAD]: SECTION_IDS.ESTADO_RESULTADOS,
    [TAB_IDS.NO_OPER]: SECTION_IDS.ESTADO_RESULTADOS,
    [TAB_IDS.KPIS]: SECTION_IDS.ESTADO_RESULTADOS,
    [TAB_IDS.BALANCE_RESUMEN]: SECTION_IDS.BALANCE,
    [TAB_IDS.ACTIVOS]: SECTION_IDS.BALANCE,
    [TAB_IDS.PASIVOS]: SECTION_IDS.BALANCE,
    [TAB_IDS.PATRIMONIO]: SECTION_IDS.BALANCE,
    [TAB_IDS.BALANCE_KPIS]: SECTION_IDS.BALANCE,
    [TAB_IDS.PRESUPUESTO]: SECTION_IDS.PROYECCIONES,
    [TAB_IDS.PROYECCION_CAJA]: SECTION_IDS.PROYECCIONES,
});

/** Sección del sidebar a la que pertenece `tab`, o null si no es un tab. */
export function sectionOfTab(tab) {
    return TAB_SECTION[tab] || null;
}

// Tabs con modal de drill por mes: el salto desde una fila del Resumen o del
// Dashboard deja un `pendingDrill` que el tab destino consume al montar.
export const TABS_WITH_DRILL = Object.freeze([TAB_IDS.VENTAS, TAB_IDS.COSTOS, TAB_IDS.GASTOS]);
